import { render } from "./WarningList.vue?vue&type=template&id=2d9ac126&scoped=true"
import script from "./WarningList.vue?vue&type=script&lang=js"
export * from "./WarningList.vue?vue&type=script&lang=js"

import "./WarningList.vue?vue&type=style&index=0&id=2d9ac126&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9ac126"]])

export default __exports__